import React, { ButtonHTMLAttributes } from "react";

import Spinner from "../Spinner";

import { Container } from "./styles";

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  fallback?: React.ReactNode;
}

const Button: React.FC<IButtonProps> = ({
  loading,
  fallback,
  children,
  ...rest
}) => {
  return (
    <Container type="button" {...rest}>
      {loading ? (
        <>
          <Spinner />
          {fallback}
        </>
      ) : (
        children
      )}
    </Container>
  );
};

export default Button;
